/**
 * Copyright © 2026 Adnuntius AS.
 * UI-Router state declarations.
 */
import {Ng2StateDeclaration} from '@uirouter/angular';
import {getRoutePageComponent, getContextRoutePageComponent} from '../common/controller/route-page-component-registry';
import {collectStatesFromProvider, AdnRouterHelperApi} from '../routing/state-utils';
import {configureAdminResourceStates} from '../common/controller/admin-resource-routing';
import politicalEntityCrumbs from './political-entity-crumbs';
import {PoliticalEntityResource} from '../../components/api/resources/resource/political-entity.resource';

export function politicalEntityStates(adnRouterHelper: AdnRouterHelperApi): Ng2StateDeclaration[] {
  const blockDeleteResolve = function(): string | null {
    const LocalUserPermissions = adnRouterHelper.services.localUserPermissions();

    return LocalUserPermissions.canEditPoliticalResources()
      ? null
      : 'You do not have permission to update political entities.';
  };

  return collectStatesFromProvider(function register($stateProvider, adnRouterHelperProvider) {
const rh = adnRouterHelperProvider.$get().createRouterHelper(
          'political-entities.political-entity',
          PoliticalEntityResource,
          'app.pol',
          'app'
        );
    
        $stateProvider.state(rh.listPath(), rh.list({
          data: {
            app: 'POLITICAL'
          },
          views: {
            'content@app': { component: getRoutePageComponent('political-entity-route') }
          }
        }));
    
        configureAdminResourceStates($stateProvider, rh, {
          objectType: 'PoliticalEntity',
          crumbParams: politicalEntityCrumbs,
          editTag: 'adn-political-entity-edit-page',
          itemData: {
            app: 'POLITICAL'
          },
          itemResolve: {
            blockDelete: blockDeleteResolve
          },
          twoPanel: {
            rightTag: 'adn-political-entity-campaigns-panel'
          }
        });
  }, adnRouterHelper);
}
